import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { DxAccordionComponent, DxTabsComponent } from 'devextreme-angular';

@Component({
    selector: 'm4u-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, AfterViewInit {

    @Input() Items: any[];

    private _selectedIndex: number;
    @Input() set SelectedIndex(value: number) {
        if (Utils.IsEmpty(value)) return;

        this._selectedIndex = value;
        this.SelectedIndexChange.emit(value);
    }
    get SelectedIndex() { return this._selectedIndex; }

    @Input() set Visible(value: boolean) {
        this._visible = value;
        this.SetVisibility();
    }

    @Input() IsShowOnlyTabs: boolean = false;
    @Input() IsShowOnlyAccordion: boolean = false;
    @Input() IsShowStepNumbers: boolean = false;
    @Input() CustomButtonText: string;
    @Input() CustomButtonIcon: string;

    @Output() SelectedIndexChange = new EventEmitter<number>();
    @Output() OnItemClick = new EventEmitter<any>();
    @Output() OnCustomButtonClicked = new EventEmitter<number>();

    @ViewChild('tabs') tabs: DxTabsComponent;
    @ViewChild('accordion') accordion: DxAccordionComponent;

    get Instance() {
        const instance = (this.tabs && this.tabs.instance) || (this.accordion && this.accordion.instance);
        if (instance && !instance['_contentReadyAction']) instance['_initContentReadyAction']();
        return instance;
    }

    private _currentItemIndex;
    private _visible = true;
    IsInitialized: boolean;

    constructor(public screen: ScreenService) { }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.IsInitialized = true;
        }, 200);
        this.accordion && this.accordion.instance.updateDimensions();
        this.SetVisibility();
        this.Instance && this.Instance.repaint();
        this._currentItemIndex = this.SelectedIndex;
    }

    onItemClick(event) {
        this.OnItemClick.emit(event);
        this.SelectedIndexChange.emit(event.itemIndex);
        if (event.itemIndex != this._currentItemIndex) {
            this.accordion && this.accordion.instance.repaint();
            this._currentItemIndex = event.itemIndex;
        }
    }

    OnCustomButtonClick(event, index) {
        if (event) event.stopPropagation();
        this.OnCustomButtonClicked.emit(index);
    }

    SetVisibility() {
        if (this.tabs) { this.tabs.visible = this._visible; }
        else if (this.accordion) { this.accordion.visible = this._visible; }
    }

    //GetPositionClass() {
    //    return `position-${this.Position}`;
    //}
}
